<template>
  <div class="references bg-white rounded-md shadow-md">
    <nav class="photo-bar flex flex-wrap items-center border-b border-gray-200">
      <a
        v-for="tab in visibleTabs"
        :key="tab.id"
        class="flex items-center px-3 py-2 -mb-px border-b-[3px] cursor-pointer first-letter:capitalize"
        :class="
          activeTabIndex === tab.id
            ? 'border-primary text-primary'
            : 'border-transparent text-gray-700'
        "
        @click="activeTabIndex = tab.id"
      >
        {{ tab.label }}
      </a>
      <div
        v-if="dropdownTabs.length"
        v-click-outside="closeDropdown"
        class="relative"
      >
        <a
          class="flex items-center px-3 py-2 -mb-px border-b-[3px] cursor-pointer first-letter:capitalize"
          :class="
            dropdownTabIds.includes(activeTabIndex)
              ? 'border-primary text-primary'
              : 'border-transparent text-gray-700'
          "
          @click="expanded = !expanded"
        >
          {{ $t("personReferences.otherProfessions") }}

          <IconComponent
            class="ml-2 transition-transform"
            :class="{ 'rotate-180': expanded }"
            icon="angle-down"
          />
        </a>

        <div
          v-show="expanded"
          class="absolute top-full left-0 z-10 min-w-[12rem] bg-white border border-gray-200 rounded shadow-md"
        >
          <a
            v-for="tab in dropdownTabs"
            :key="tab.id"
            class="block px-4 py-2 cursor-pointer hover:bg-gray-100"
            :class="{ 'bg-[#e4e8f7] text-[#485fc7]': activeTabIndex === tab.id }"
            @click="
              expanded = false;
              activeTabIndex = tab.id;
            "
          >
            {{ tab.label }}
          </a>
        </div>
      </div>
    </nav>
    <ImageGallery
      v-if="activeTab"
      :images="activeTab.photos"
      type="reference-photo"
      class="photo-gallery"
    />
  </div>
</template>

<script>
import ImageGallery from "../global/ImageGallery.vue";

export default {
  components: { ImageGallery },
  props: {
    photos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeTabIndex: 0,
      tabs: [],
      expanded: false,
    };
  },
  computed: {
    activeTab() {
      return this.tabs.find((x) => x.id === this.activeTabIndex);
    },
    visibleTabs() {
      return this.tabs.slice(0, 2);
    },
    dropdownTabs() {
      return this.tabs.slice(2);
    },
    dropdownTabIds() {
      return this.dropdownTabs.map((x) => x.id);
    },
  },
  created() {
    const tabMap = new Map();
    const profession = this.$route.query?.profession;
    for (const photo of this.photos) {
      const profId = photo.profession?.id || "-1";
      const label =
        photo.profession?.name || this.$t("personReferences.generic");
      let tab = tabMap.get(profId);
      if (!tab) {
        tab = {
          id: profId,
          profession: photo.profession?.seoName || "generic",
          label,
          photos: [],
        };
        tabMap.set(profId, tab);
      }
      tab.photos.push({
        name: photo.name,
        description: photo.note,
      });
    }
    let priorityTab;
    tabMap.forEach((value) => {
      if (profession && profession === value.profession) {
        priorityTab = value;
      } else {
        this.tabs.push(value);
      }
    });
    this.tabs.sort(
      (a, b) => parseInt(b.photos.length) - parseInt(a.photos.length)
    );
    if (priorityTab) {
      this.tabs.unshift(priorityTab);
    }
    this.activeTabIndex = this.tabs?.[0]?.id;
  },
  methods: {
    closeDropdown() {
      this.expanded = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.references {
  padding: 1rem;
}

.photo-gallery {
  padding: 2em 1em 1em;
}
</style>
